import React from 'react'
import { FormattedMessage, useIntl  } from 'react-intl';
import { Link } from "react-router-dom";
import { Space, Popconfirm } from 'antd';
import { CheckOutlined, StopOutlined } from '@ant-design/icons';
import SearchTable from './SearchTable'
import { SERVERS_PATH } from '../utils/constants';
import { compareStrings, TrimNan, formatBytes } from '../utils/utils';

const PolledServersTable = (props) => {  
    const intl = useIntl();

    function OnEdit(record)
    {
        props.onEdit({...record, "isPolled" : true});
    }

    function onDelete(id)
    {
        props.onDelete({"id" : id, "isPolled" : false});
    }

    let layout = {
        bordered : true,
        showSizeChanger : false, 
        pagination : {pageSize: 50, showSizeChanger: false},
        size: "small",
        rowKey : record => record.id,
    };

    let columns = [
        {
          title: <FormattedMessage id="DeviceMetersTable.name"/>,
          dataIndex: 'name',
          
          search: true,
          sorter: {
            compare: (a, b) => compareStrings(a.name, b.name),
          },
          render: (_, record) => {
            const url = SERVERS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
          }
        },
        {
            title: <FormattedMessage id="Address"/>,
            dataIndex: 'pollingUrl',
            
            search: true,
            sorter: {
              compare: (a, b) => compareStrings(a.pollingUrl, b.pollingUrl),
            },
            render: (_, record) => {
              return(
              <div>
                  <a href={'http://' + record.pollingUrl} target='_blank' rel="noopener noreferrer">{record.pollingUrl}</a>
              </div>
              );
            }
        },
        {
            title: <FormattedMessage id="Interval"/>,
            dataIndex: 'pollingInterval',
            
            search: true,
            sorter: {
                compare: (a, b) =>  TrimNan(a.pollingInterval) -  TrimNan(b.pollingInterval)
            },
            render: (_, record) => {
                return(
                    <div>
                        {record.pollingInterval} <FormattedMessage id="Minutes"/>
                    </div>
                );
            } 
        },
        {
            title: <FormattedMessage id="JobData"/>,
            dataIndex: 'extractJobData',
            align: 'center',
            
            search: false,
            sorter: {
                compare: (a, b) =>  TrimNan(a.extractJobData) -  TrimNan(b.extractJobData)
            },
            render: (_, record) => {
                if (TrimNan(record.extractJobData) !== 0)
                {
                    return(<CheckOutlined/>);
                }
                else
                {
                    return(<StopOutlined/>);
                }
            } 
        },
        {
            title: <FormattedMessage id="LastJobDateTime"/>,
            dataIndex: 'lastJobDateTime',
                            
            sorter: {
              compare: (a, b) => 
              {
                  const time_a = Date.parse(a.lastJobDateTime);
                  const time_b = Date.parse(b.lastJobDateTime);
                  return time_a - time_b;
              }
            },
            search: true,
            render: (_, record) =>
            <div>
                {record.lastJobDateTime !== undefined && new Date(record.lastJobDateTime).toLocaleString(navigator.language || navigator.userLanguage)}
            </div>
        },
        {
            title: <FormattedMessage id="LastALive"/>,
            dataIndex: 'lastAlive',
                            
            sorter: {
              compare: (a, b) => 
              {
                  const time_a = Date.parse(a.lastAlive);
                  const time_b = Date.parse(b.lastAlive);
                  return time_a - time_b;
              }
            },
            search: true,
            render: (_, record) =>
            <div>
                {record.lastAlive !== undefined && new Date(record.lastAlive).toLocaleString(navigator.language || navigator.userLanguage)}
            </div>
        },
        {
            title: <FormattedMessage id="TotalRecords"/>,
            dataIndex: 'documents',
            
            search: true,
            sorter: {
                compare: (a, b) =>  TrimNan(a.documents) -  TrimNan(b.documents)
            },
        },
        {
            title: <FormattedMessage id="TotalImagesSize"/>,
            dataIndex: 'jobDataSize',
            
            search: true,
            sorter: {
                compare: (a, b) =>  TrimNan(a.jobDataSize) -  TrimNan(b.jobDataSize)
            },
            render: (_, record) => {
                return(
                    <div>
                    {formatBytes(record.jobDataSize)}
                    </div>
                );
            } 
        },
        {
            title: <FormattedMessage id="Action"/>,
            key: 'action',
            render: (_, record) =>
                  <Space size="middle">
                      <a href="#!"onClick={() => OnEdit(record)}><FormattedMessage id="Edit"/></a>
                      <Popconfirm title={intl.formatMessage({ id: "DeleteConfirm" })} onConfirm={() => onDelete(record.id)}>
                      <a href="#!"><FormattedMessage id="Delete"/></a>
                      </Popconfirm>
                  </Space>
          },        
    ];
  
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = {undefined}
                columns={columns} 
                dataSource={props.data} 
            />                
        </div>
    );   

}
  
export default PolledServersTable;